// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { VideoClass } from '@/lib/types/api/video';

// components
import MyListVideoGridItem from '@/components/MyList/MyListVideos/MyListVideoGridItem';

// styles
import styles from './MyListVideosGrid.module.scss';

interface MyListVideosGridProps {
  videos: VideoClass[];
}

const MyListVideosGrid = (props: MyListVideosGridProps) => {
  const { videos } = props;

  return (
    <div className={styles.my_list_videos_grid} data-sentry-component="MyListVideosGrid" data-sentry-source-file="MyListVideosGrid.tsx">
      {videos.map((video, i: number) => {
        return (
          <MyListVideoGridItem video={video} key={i} />
        )
      })}
    </div>
  );
};

export default MyListVideosGrid;
